import { createContext } from "react";

export type SubscriptionActionsContextType = {
  setIsSubscriptionActionLoading: React.Dispatch<React.SetStateAction<boolean>>;
  isSubscriptionActionLoading: boolean;
};

export const SubscriptionActionsContext =
  createContext<SubscriptionActionsContextType>(
    {} as SubscriptionActionsContextType,
  );
